<template>
    <b-modal visible centered hide-footer hide-header size="md" :no-close-on-backdrop="isLoading" @hidden="routerBack">
        <h4 class="text-center">{{ title }}</h4>
        <div class="p-2">
            <b-form-group
                :state="isValid"
                :label="$tc('values.selectDesiredNetworks', translation)"
                :invalid-feedback="$tc('values.selectSomeNetwork', translation)"
                :disabled="isLoading"
            >
                <b-form-checkbox switch v-model="value.updateLeader">
                    {{ $t('values.table.leader') }}
                </b-form-checkbox>
                <b-form-checkbox switch v-model="value.updateTeam">
                    {{ $t('values.table.team') }}
                </b-form-checkbox>
                <b-form-checkbox switch v-model="value.updatePeers">
                    {{ $t('values.table.peer') }}
                </b-form-checkbox>
            </b-form-group>
            <div class="text-center">
                <b-button class="mr-3" size="sm" :disabled="isLoading" @click="routerBack">
                    <span>{{ $t('modal.cancel') }}</span>
                </b-button>
                <b-button size="sm" variant="primary" :disabled="isLoading" @click="onClickConfirm">
                    <i v-if="isLoading" class="fa fa-spinner fa-spin px-2" />
                    <span v-else>{{ btnConfirmText }}</span>
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import i18n from '@/i18n'
import Swal from 'sweetalert2'

export default {
    name: 'UsersNetworkModal',
    inheritAttrs: false,
    props: {
        isLoading: {
            type: Boolean,
            required: true,
            default: false,
        },
        value: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        btnConfirmText: {
            type: String,
            required: true,
        },
        translation: {
            type: String | Number,
            required: true,
        },
    },
    methods: {
        onClickConfirm() {
            if (!this.isValid) {
                Swal.fire({
                    type: 'warning',
                    focusConfirm: true,
                    confirmButtonColor: '#20A8D8',
                    title: i18n.t('notification.warning'),
                    text: i18n.t('values.selectSomeNetworkToUpdate'),
                })
            } else {
                this.$emit('onConfirm', this.routerBack, this.notificationSuccess, this.notificationError)
            }
        },
        routerBack() {
            this.$router.back(-1)
        },
        notificationSuccess() {
            Swal.fire({
                type: 'success',
                focusConfirm: true,
                confirmButtonColor: '#20A8D8',
                title: i18n.t('notification.requestSentSuccessfully'),
                text: i18n.t('notification.updateUsersNetworkSuccess'),
            })
        },
        notificationError() {
            Swal.fire({
                type: 'error',
                focusConfirm: true,
                confirmButtonColor: '#20A8D8',
                title: i18n.t('notification.danger'),
                text: i18n.t('notification.somethingWentWrong'),
            })
        },
    },
    computed: {
        isValid() {
            return this.value.updateTeam || this.value.updatePeers || this.value.updateLeader
        },
    },
}
</script>
